import { cn } from "@bidbattles/bloks/lib/ui";
import { ParaglideMessage } from "@inlang/paraglide-js-react";

function Strong({
	className,
	children,
	primary = false,
}: React.PropsWithChildren<{ primary?: boolean; className?: string }>) {
	return (
		<strong className={cn(primary && "text-accent-primary", className)}>
			{children}
		</strong>
	);
}

export const i18nComponents = { Strong };
